import { typeBuilder } from 'base/shared/TypeHelper';

export default typeBuilder(['FEATURES_REQUEST', 'FEATURES_SUCCESS', 'FEATURES_ERROR']);
